import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";
import UFOSegment from "@atlaskit/react-ufo/segment";

import ContentBlock from "@/components/wpl/content-block/src";
import { wacToken } from "@/libraries/design/foundations";
import { useLocalizedHref } from "@/libraries/web-framework";

const heroContainerStyles = css({
    "backgroundColor": "#1868DB",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "100%",
    "maxWidth": "1301px",
    "margin": "0 auto",
    "gap": "32px",
    "position": "relative",
    "padding": "58px 0 73px 0",
    "border": "0",
    "clipPath":
        "polygon(0.000px 0.445px, 1301.000px 27.008px, 1301.000px 100%, 0.000px calc(100% - 7.512px), 0.000px 0.445px)",
    [media.below.md]: {
        padding: "64px 60px 64px 60px"
    },
    [media.below.sm]: {
        flexDirection: "column",
        padding: "64px 32px 41px 32px"
    },

    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".contentBlock-linkFlex": {
        margin: "0px"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".textContainerStyles": {
        "width": "100%",
        "maxWidth": "368px",
        [media.only.sm]: {
            flex: 1
        },
        // Tech debt: Adding this disable to unblock commits for GWP-2646
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".text-section": {
            gap: "8px",
            // Tech debt: Adding this disable to unblock commits for GWP-2646
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            h2: {
                color: wacToken("color.neutral.light0"),
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "30px" /* 125% */,
                letterSpacing: "0.3px",
                width: "100%",
                maxWidth: "368px",
                margin: "0",

                [media.below.md]: {
                    fontSize: "22px",
                    lineHeight: "28px" /* 127.273% */
                },
                [media.below.sm]: {
                    fontSize: "20px",
                    lineHeight: "26px" /* 130% */
                }
            },
            // Tech debt: Adding this disable to unblock commits for GWP-2646
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            p: {
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "24px",
                margin: "0",
                fontSize: "1rem",
                width: "100%",
                maxWidth: "368px",
                color: wacToken("color.neutral.light0"),
                marginBlockEnd: "8px"
            },
            // Tech debt: Adding this disable to unblock commits for GWP-2646
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                margin: "0 !important"
            },

            [media.below.sm]: {
                alignItems: "center",
                textAlign: "center"
            }
        }
    }
});

const imageContainerStyles = css({
    position: "relative"
});

const imageStyles = css({
    width: "311px",
    height: "207.897px",
    flex: "none",
    [media.only.sm]: {
        display: "flex",
        alignItems: "center",
        flex: 1,
        width: "unset",
        height: "unset"
    },
    [media.above.sm]: {
        width: "368px",
        height: "246px"
    }
});

export const CommunitySectionImage = () => {
    return (
        <div css={imageContainerStyles}>
            {/* eslint-disable-next-line no-restricted-syntax */}
            <img
                alt=""
                css={imageStyles}
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-feature-v2-community-globe.webp"
                loading="lazy"
            />
        </div>
    );
};

export const CommunitySection = () => {
    const intl = useIntl();

    const headerText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CommunityGraphic.Header",
        defaultMessage: "Connect with our 4.5M+ community members"
    });
    const descriptionText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CommunityGraphic.Description",
        defaultMessage:
            "Ask questions, give product feedback, and connect with our team and other users to learn best practices. From events and forums, to curated learning paths, you’re never alone when you are an Atlassian customer."
    });
    const buttonText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CommunityGraphic.Cta",
        defaultMessage: "Check out community"
    });

    return (
        <UFOSegment name="hero">
            <div
                css={css({
                    backgroundImage: `linear-gradient(1deg, transparent, transparent 45%, ${wacToken(
                        "color.neutral.light100"
                    )} 45.1%, ${wacToken("color.neutral.light100")})`
                })}
            >
                <div css={heroContainerStyles}>
                    <ContentBlock
                        headerText={headerText}
                        headerType="h2"
                        bodyText={descriptionText}
                        className="textContainerStyles"
                        ctaProps={{
                            primaryLinkProps: {
                                text: buttonText,
                                href: useLocalizedHref("/community"),
                                className: "jiraLinkStyling",
                                dataEventProps: {
                                    "data-product-key": "jiraSoftware",
                                    "data-event": "clicked",
                                    "data-event-container":
                                        "communityCtaSection",
                                    "data-event-component": "link"
                                },
                                bgColor: "bgBlackBlue"
                            }
                        }}
                    />
                    <CommunitySectionImage />
                </div>
            </div>
        </UFOSegment>
    );
};
